export default class Submenu {
  constructor(data = {}) {
    return {
      id: data.id || "",
      name: data.name || "",
      menuid: data.menuid || "",
    };
  }
}
